<template>
  <layout-content>
    <edit-form v-bind="form_data" />
  </layout-content>
</template>
<script>
  import EditForm from '@autoinformer/components/campaigns-edit-form.vue';
  import { mapMutations } from 'vuex';
  import { CampaignsService } from '@autoinformer/services/CampaignsService';
  export default {
    components: { EditForm },
    data() {
      return {
        form_data: {
          id: null,
          item: null
        }
      };
    },
    created() {
      const id = this.$route.params.id;
      this.set_campaign_id(id);

      CampaignsService.getItem(id)
        .then((item) => {
          const { id } = item;
          this.form_data = { id, item };

          this.endLoadingPage();
        })
        .catch((e) => this.showPageError(e));
      // }
    },

    beforeDestroy() {
      this.set_campaign_id(null);
    },

    methods: {
      ...mapMutations({
        set_campaign_id: 'autoinformer/campaigns/tasks/campaign_id'
      })
    }
  };
</script>
